module.exports = __webpack_public_path__ + "img/avatar_random_9.9d3fa557.png";